
const loggedInGlobalUser = {
    operator: null,
    email: null,
    aliasName: null,
    title: null,
  };
  
  const UserService = {
    getUserInfoFromLocalStorage: () => {
      const loggedInUser = localStorage.getItem("loggedInUser");
  
      if (loggedInUser) {
        const userObject = JSON.parse(loggedInUser);
        Object.assign(loggedInGlobalUser, userObject);
      }
      return loggedInGlobalUser
    },
  
    setUserInfoToNull: () => {
      loggedInGlobalUser.operator = null;
      loggedInGlobalUser.email = null;
      loggedInGlobalUser.aliasName = null;
      loggedInGlobalUser.title = null;
    },
  };
  
  export default UserService;
  